import { EnumNoRiskWallet } from "src/utils/constant";

export interface FieldsFace {
  max_sweepable_address: string;
  chain_name: string;
  receivingAddressDictionary: Record<number, { receivingAddress: string }>;
  invokerAddressDictionary: Record<number, { invokerAddress: string }>;
  asset_name: string;
  threshold: string;
  risk_level: string;
  acceptant_risk_level_array: string[];
  include_no_risk_level_wallet: string;
  is_smart_account: boolean;
  is_free_bandwidth_only: boolean;
  wallet_version: string;
}

export const initFields: FieldsFace = {
  max_sweepable_address: "1000",
  chain_name: "",
  receivingAddressDictionary: {},
  invokerAddressDictionary: {},
  asset_name: "",
  threshold: "",
  risk_level: "",
  acceptant_risk_level_array: [],
  include_no_risk_level_wallet: `${EnumNoRiskWallet.notIncludeNoRiskWallet}`,
  is_smart_account: false,
  is_free_bandwidth_only: false,
  wallet_version: "",
};
